import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'
// import VueLazyload from 'vue-lazyload'
import axios from 'axios'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'


// import MovieList from '@/components/MovieList'
// import DPlayer from '@/components/DPlayer'

// Vue.component('MovieList', MovieList)
// Vue.component('DPlayer', DPlayer)

// Vue.use(VueLazyload, {
//   preLoad: 1.3, // 预加载高度比例
//   // error: 'path/to/error-image.png', // 加载失败时显示的图片
//   // loading: 'path/to/loading-image.gif', // 加载时显示的占位图
//   attempt: 3 // 尝试加载次数
// })
// Vue.use(ElementUI)

Vue.use(VueGtag, {
  config: { id: 'G-SJ9CYMGMKE' } 
  // config: { id: 'G-SJ9CYMGMKE' },          // 你的 GA4 测量 ID
  // disabled: true                          // 完全禁用 GA（适用于开发环境）
}, router) // 传入 router 以启用自动路由跟踪

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$base_url = 'http://localhost:8080/'
// Vue.prototype.$base_url = 'https://www.mqttbox.asia/'
// Vue.prototype.$base_url = 'https://9cbb.ggff.net/'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
